/**
 * A number of tile directives to ease rendering of common ui components
 *
 * @author  Mark Cremer <mark@firstcoders.co.uk>
 */
(function() {
    'use strict';

    angular.module('pitch.app')

    .directive('satvTile',
        function() {
            return {
                restrict: 'A',
                scope: {
                    item: '=satvTile',
                },
                template:   '<div ng-if="::item.category == \'news\'" satv-news-tile="item"></div>' +
                            '<div ng-if="::item.category == \'playlist\'" satv-playlist-tile="item"></div>' +
                            '<div ng-if="::item.category == \'instagram\'" satv-instagram-tile="item"></div>' +
                            '<div ng-if="::item.category == \'socialinstagram\'" satv-socialinstagram-tile="item"></div>' +
                            '<div ng-if="::item.category == \'synch\'" satv-synch-tile="item"></div>'
            };
        }
    )

    .directive('satvPlaylistTile',
        function() {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    content: '=satvPlaylistTile',
                    showLabel: '=',
                    showCaption: '='
                },
                compile: function(element, attrs) {
                    attrs.showLabel = attrs.showLabel || 'true';
                    attrs.showCaption = attrs.showCaption || 'true';
                },
                template: '<a ng-init="img = (content.assets|asset:\'thumbnail\')" ng-class="::showCaption ? \'rect\' : \'square\'" class="thumbnail caption-box shadow-box hover-shadow animate mask-wrapper" ui-sref="featuredPlaylist({id: content.id, title: content.subject.name})">' +
                              '<img alt="[[::img.alt]]" width="350" height="350" ng-src="[[::img.src]]" />' +
                              '<div ng-if="::showLabel" class="label label-playlist hover-fade-out animate-opacity">Playlist</div>' +
                              '<div ng-if="::showCaption" class="caption align-bottom">' +
                                  '<div class="title">[[::content.subject.name]]</div>' +
                                  '<div class="date"><small>[[::content.created_date | date: \'mediumDate\' ]]</small></div>' +
                              '</div>' +
                              '<div class="hover-fade-in mask center-contents mask-dark-6 animate">' +
                                  '<div class="icon-circle emphasis">' +
                                      '<div class="circle animate">' +
                                          '<i aria-hidden="true" class="icon fa fa-play"></i>' +
                                          '<span class="sr-only">Play</span>' +
                                      '</div>' +
                                  '</div>' +
                              '</div>' +
                          '</a>'
            };
        }
    )

    .directive('satvSynchTile',
        function() {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    synch: '=satvSynchTile',
                    showLabel: '=',
                    showCaption: '='
                },
                compile: function(element, attrs) {
                    attrs.showLabel = attrs.showLabel || 'true';
                    attrs.showCaption = attrs.showCaption || 'true';
                },
                template: '<a ng-init="::img = (synch.assets | asset:\'thumbnail\')" ng-class="::showCaption ? \'rect\' : \'square\'" class="thumbnail caption-box shadow-box hover-shadow animate mask-wrapper" ui-sref="synch({play: synch.id})">' +
                              '<img alt="[[::img.alt]]" ng-src="[[::img.src]]" width="350" height="350" />' +
                              '<div ng-if="::showLabel" class="label label-synch hover-fade-out animate-opacity">Synch</div>' +
                              '<div  ng-if="::showCaption" class="caption align-bottom">' +
                                  '<div class="title">[[::synch.title]]</div>' +
                                  '<div class="date"><small>[[::synch.created_date | date:\'mediumDate\']]</small></div>' +
                              '</div>' +
                              '<div class="hover-fade-in mask center-contents mask-dark-6 animate">' +
                                  '<div class="icon-circle emphasis">' +
                                      '<div class="circle animate">' +
                                          '<i aria-hidden="true" class="icon fa fa-play"></i>' +
                                          '<span class="sr-only">Play</span>' +
                                      '</div>' +
                                  '</div>' +
                              '</div>' +
                          '</a>'
            };
        }
    )

    .directive('satvNewsTile',
        function() {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    news: '=satvNewsTile',
                    showLabel: '=',
                    showCaption: '=',
                    slideUp: '='
                },
                compile: function(element, attrs) {
                    attrs.showLabel = attrs.showLabel || 'true';
                    attrs.showCaption = attrs.showCaption || 'true';
                    attrs.slideUp = attrs.slideUp || 'true';
                },
                template: '<a ng-init="img = (news.assets|asset:\'thumbnail\')" ng-class="::slideUp ? showCaption ? \'rect\' : \'square\' : \'\'" class="thumbnail caption-box shadow-box hover-shadow animate" ui-sref="newsArticle({id: [[::news.id]], name: \'[[::news.title]]\'})">' +
                              '<img alt="[[::img.alt]]" width="350" height="350" ng-src="[[::img.src]]" />' +
                              '<div ng-if="::showLabel" class="label label-news hover-fade-out animate-opacity">News</div>' +
                              '<div ng-if="::showCaption" class="caption" ng-class="{\'align-bottom animate slide-up\': slideUp}">' +
                                  '<div class="title">[[::news.title]]</div>' +
                                  '<div class="date"><small>[[::news.date | date: \'mediumDate\']]</small></div>' +
                                  '<p>[[::news.introduction]]</p>' +
                              '</div>' +
                          '</a>'
            };
        }
    )
    .directive('satvSocialinstagramTile',
        function() {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    content: '=satvSocialinstagramTile',
                    showLabel: '=',
                    showCaption: '=',
                    slideUp: '='
                },
                compile: function(element, attrs) {
                    attrs.showLabel = attrs.showLabel || 'true';
                    attrs.showCaption = attrs.showCaption || 'true';
                    attrs.slideUp = attrs.slideUp || 'true';
                },
                template: '<a ng-class="::slideUp ? showCaption ? \'rect\' : \'square\' : \'\'" class="thumbnail caption-box shadow-box hover-shadow animate" ng-href="[[content.url]]" target="_blank">' +
                              '<img alt="[[::content.title]]" width="350" height="350" ng-src="[[::content.image]]" />' +
                              '<div ng-if="::showLabel" class="label label-news hover-fade-out animate-opacity">Instagram</div>' +
                              '<div ng-if="::showCaption" class="caption" ng-class="{\'align-bottom animate slide-up\': slideUp}">' +
                                  '<div class="title">[[::content.title]]</div>' +
                                  '<p>[[::content.body]]</p>' +
                              '</div>' +
                          '</a>'
            };
        }
    )
    .directive('satvInstagramTile',
        function() {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    content: '=satvInstagramTile',
                    showLabel: '=',
                    showCaption: '=',
                    slideUp: '='
                },
                compile: function(element, attrs) {
                    attrs.showLabel = attrs.showLabel || 'true';
                    attrs.showCaption = attrs.showCaption || 'true';
                    attrs.slideUp = attrs.slideUp || 'true';
                },
                link: function(scope) {
                    scope.isTall = false;
                },
                // language=HTML
                template: '<a class="thumbnail thumbnail--instagram caption-box shadow-box hover-shadow animate" ng-class="{' +
                    'rect: showCaption && slideUp,' +
                    'square: showCaption && !slideUp' +
                '}" target="_blank" ng-href="[[::content.data.permalink || \'https://www.instagram.com/\' + content.account.username]]">' +
                    '<img alt="[[::content.data.account.title]] ([[::content.data.account.username]])" ng-src="[[::content.data.media_url || content.account.profile_picture_url ]]" />' +
                    '<div ng-if="::showLabel" class="label label-news hover-fade-out animate-opacity">Instagram</div>' +
                    '<div ng-if="::showCaption" class="caption" ng-class="{\'align-bottom animate slide-up\': slideUp}">' +
                        '<div class="title" ng-if="content.data.caption">[[content.data.caption]]</div>' +
                        '<div class="date" ng-if="content.data.timestamp"><small>[[::content.data.timestamp | date: \'mediumDate\']]</small></div>' +
                        '<div class="title" ng-if="content.account.title">[[::content.account.title]] <small>(@[[::content.account.username]])</small></div>' +
                    '</div>' +
                '</a>'
            };
        }
    );
})();



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/tiles.js